import { Flex } from '@billy/design-system'
import { ReactElement, useMemo } from 'react'

import { DocumentHtmlPreview } from '@features/invoices/elements/DocumentHtmlPreview'

import { useQuote } from '../../contexts/quoteContext'
import { useFetchQuoteHtml } from '../../hooks/useFetchQuoteHtml'
import * as Styled from './styles'

export const QuotePreview = (): ReactElement => {
  const { quoteId } = useQuote()
  const { quoteHtml } = useFetchQuoteHtml(quoteId)

  const htmlFiles = useMemo(() => (quoteHtml ? [quoteHtml] : []), [quoteHtml])

  return (
    <Styled.QuoteHtmlPreviewWrapper>
      <Flex justifyContent="center">
        <DocumentHtmlPreview htmlFiles={htmlFiles} key={quoteId} />
      </Flex>
    </Styled.QuoteHtmlPreviewWrapper>
  )
}
